import $ from 'jquery';
import Constants from './Constants';


const PAGE_CONFIGURATION = {
  DEFAULT: {
    SMALL: Constants.RESPONSIVE_PROS_WIDTH.SMALL,
    MEDIUM: Constants.RESPONSIVE_PROS_WIDTH.MEDIUM,
    LARGE: Constants.RESPONSIVE_PROS_WIDTH.LARGE,
  },
  [Constants.PAGE.HOME_PAGE]: {
    SMALL: 220,
    MEDIUM: 280,
    LARGE: 296,
  },
  [`${Constants.PAGE.RESPONSIVE_BAG}_${Constants.SB_ZONES.SB_ZONE_C}`]: {
    HAS_FIXED_SIZE: true,
  },
};

class ResponsiveThumbnailSizeDecider {
  constructor() {
    if (!ResponsiveThumbnailSizeDecider.instance) {
      ResponsiveThumbnailSizeDecider.instance = this;
    }
    return ResponsiveThumbnailSizeDecider.instance;
  }

  breakpointScreenItemWidth(page, zone) {
    const values = PAGE_CONFIGURATION[`${page}_${zone}`] || PAGE_CONFIGURATION[page] || PAGE_CONFIGURATION.DEFAULT;
    const width = $(window).width();
    if (width < Constants.BREAK_POINTS.SMALL) {
      return values.SMALL;
    } else if (width > Constants.BREAK_POINTS.MEDIUM) {
      return values.LARGE;
    }
    return values.MEDIUM;
  }

  hasBreakpointScreenSizeChange(page, zone) {
    const values = PAGE_CONFIGURATION[`${page}_${zone}`] || PAGE_CONFIGURATION[page] || PAGE_CONFIGURATION.DEFAULT;
    return !values.HAS_FIXED_SIZE;
  }
}

const instance = new ResponsiveThumbnailSizeDecider();

Object.freeze(instance);

export default instance;
